import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestService } from './rest-service';
import { ISponsorResponse } from 'src/app/core/models/i-sponsor-response';

@Injectable({
  providedIn: 'root',
})
export class SponsorService {
  static readonly ENTITY_IDENTIFIER: string = 'sponsors';
  private readonly BASE_SPONSORS_ROUTE = `api/${SponsorService.ENTITY_IDENTIFIER}`;
  private readonly BUILD_HTTP_ROUTE = (...args) =>
    this.restService.BUILD_HTTP_ROUTE(this.BASE_SPONSORS_ROUTE, ...args);

  constructor(private restService: RestService) {}

  getFilteredBySearchText$(searchText: string): Observable<ISponsorResponse> {
    const params = this.restService.buildHttpParamsObject({
      searchText: searchText.trim(),
    });
    return this.restService.get$<ISponsorResponse>(this.BUILD_HTTP_ROUTE(), {
      params,
    });
  }

  getPagedFilteredBySearchText$(
    searchText: string,
    pageNumber: number,
    pageSize: number,
  ): Observable<ISponsorResponse> {
    const params = this.restService.buildParamsObjectWithPaging(
      {
        searchText: searchText.trim(),
      },
      pageNumber,
      pageSize,
    );
    return this.restService.get$<ISponsorResponse>(this.BUILD_HTTP_ROUTE(), {
      params,
    });
  }
}
